import { ReactComponent as IconSvg } from './icon_eye.svg';
import Icon, { IconProps } from './icon';

const IconEye = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconEye;
